import React from "react";
import { useParams } from "react-router-dom";
import SolidBlueBtn from "../../components/buttons/SolidBlueBtn";
import TopPageBack from "../../components/TopPageBack";

const TermAndPolicyDetails = () => {
  const params = useParams();
  return (
    <div>
      <TopPageBack>
        <b>{params.title}</b>
      </TopPageBack>
      <div className="mt-4 mx-5">
        <div className="text-22 text-darkblue font-bold">
          <div>개인정보 및 고유식별정보</div>
          <div>수집 및 이용 동의</div>
        </div>

        <select className="app-dropdown mt-9 mb-8">
          <option value="2023.08.16">2023.08.16</option>
        </select>

        <div
          style={{ border: "1px solid #E0E3ED" }}
          className="rounded-2xl text-center "
        >
          <div
            style={{ borderBottom: "1px solid #E0E3ED" }}
            className="rounded-t-2xl bg-gray text-darkblue text-base font-bold py-4 px-7"
          >
            수집항목
          </div>
          <div className="py-4 px-9 text-15">
            금융기관명, 출금계좌, 성명, 생년월일, 휴대폰번호
          </div>
          <div
            style={{
              borderBottom: "1px solid #E0E3ED",
              borderTop: "1px solid #E0E3ED",
            }}
            className="bg-gray text-darkblue text-base font-bold py-4 px-7"
          >
            보유 및 이용기간
          </div>
          <div className="py-4 px-9 text-15">
            동의일로부터 자동이체 종료일 (해지일)
          </div>
        </div>

        <div className="mt-9">
          <div className="term-item">
            <div className="term-heading">제1조 목적</div>
            <div className="term-content">
              본 약관은 (주)에스피지이(이하 "회사"라 한다)가 제공하는 "서비스"를
              이용함에 있어 필요한 "회사"와 "신청자" 간의 권리와 의무사항을
              규정함을 목적으로 합니다.
            </div>
          </div>

          <div className="term-item">
            <div className="term-heading">제2조 용어의 정의</div>
            <div className="term-content">
              1. "서비스"라 함은 "회사"가 "신청자"의 신청에 의해 제공하는 배달앱
              리뷰 및 댓글 관리를 의미합니다.
              <br />
              <br />
              2. “신청자”라 함은 “회사”의 “서비스”를 이용하기 위해 “매장”의
              대표자 또는 대표자에게 위임을 받은 자를 의미합니다.
              <br />
              <br />
              3. "매장"이라 함은 "회사"가 제공하는 "서비스"를 이용하기 위해 이
              약관에 따라 “신청자”가 "회사"와 서비스 신청서를 작성하고 "회사"가
              제공하는 "서비스"를 이용하는 사업자를 의미합니다.
            </div>
          </div>

          <div className="term-item">
            <div className="term-heading">제3조 약관의 명시와 개정</div>
            <div className="term-content">
              1. "회사"는 이 약관의 내용을 서비스 신청서에 표시합니다.
              <br />
              <br />
              2. "회사"는 필요 시 관련 법령을 위배하지 않는 범위 내에서 본
              약관을 개정할 수 있으며, 이 경우 개정내용과 적용일자를 "회사"의
              홈페이지 초기화면을 통하여 그 적용일자 15일전부터 적용일 전일까지
              공지합니다.
              <br />
              <br />
              3. "신청자"가 개정약관에 동의하지 않는 경우, 개정약관의 적용일
              이전에 거부의사를 표현하고 "서비스"를 해지할 수 있습니다.
            </div>
          </div>

          <div className="term-item">
            <div className="term-heading">제4조 서비스 신청과 이용</div>
            <div className="term-content">
              1. "서비스"를 이용하고자 하는 "신청자"는 "회사"가 정한 절차에 따라
              본 약관에 동의하고 신청하여야 하며, "회사"는 이를 승낙함으로써
              체결됩니다.
              <br />
              <br />
              2. "회사"는 다음 각 호의 경우 "신청자"의 “서비스” 신청을 취소할 수
              있습니다.
              <br />
              <br />
              ① 서비스 신청서의 내용이 허위로 판명되거나 허위 서류를 제출하였을
              경우
              <br />
              ② "신청자"가 타인의 상호, 전화번호, 사업자등록번호 등으로 신청하는
              경우
              <br />
              ③ 타 "매장"의 "서비스" 이용방해, 정보도용 및 악용하는 등의 행위를
              하였을 경우
              <br />
              ④ 관련법령과 본 약관이 금지하는 행위를 하는 경우
              <br />
              ⑤ 기타 "회사"가 정한 기준에 적합하지 않은 경우
              <br />
              <br />
              3. "회사"는 "신청자"가 제공한 내용이 "회사"가 정한 기준에 미비한
              사항이 있을 경우 “서비스” 신청을 보류할 수 있습니다.
              <br />
              <br />
              4. "서비스" 이용기간은 서비스 신청서에 표시된 서비스 시작일을
              기준으로 하며, “신청자” 또는 “회사”의 요청이 없을 경우 1개월
              단위로 자동 연장됩니다.
              <br />
              <br />
              5. "서비스"의 비용은 "회사"가 "신청자"에게 사전 통보 후 변경할 수
              있습니다.
            </div>
          </div>

          <div className="term-item">
            <div className="term-heading">제5조 정보 수집 및 이용</div>
            <div className="term-content">
              1. "회사"는 "서비스" 제공과 “서비스”의 비용 수납을 위하여 관련
              법령이 규정한 절차와 방법에 따라 "신청자"로부터 필요한 정보를
              수집합니다.
              <br />
              <br />
              2. "회사"는 "서비스"에 필요한 "매장"의 사업자명, 사업자등록번호,
              대표자명, 사업자주소, 배달앱 ID/PW 및 “서비스”의 비용 수납에
              필요한 은행명, 계좌번호, 예금주명, 예금주 생년월일/사업자번호,
              연락처 등 다양한 정보를 수집하여 등록합니다.
              <br />
              <br />
              3. 전 항의 정보 수집, 등록, 관리 업무는 "회사"가 실시합니다.
              <br />
              <br />
              4. "매장"의 최초 정보 등록 이후 입력사항이 변경되었을 경우
              "신청자"는 "회사"에게 즉시 통지하여 이를 변경하여야 합니다. 정보
              변경 통지를 하지 아니하여 발생하는 손해에 대해서는 “회사”는 책임을
              부담하지 않습니다.
              <br />
              <br />
              5. "회사"는 “서비스”의 시작일로부터 해지 후 5년까지 수집한 정보를
              보유 및 이용합니다.
              <br />
              <br />
              6. "신청자"는 "회사"가 "매장"의 정보 수집 및 이용을 거부할 권리가
              있으며, 권리 행사 시 "서비스"의 신청이 거부될 수 있습니다.
            </div>
          </div>

          <div className="term-item">
            <div className="term-heading">제6조 제3자 정보 제공 동의</div>
            <div className="term-content">
              1. "회사"는 "신청자"에게 제공받은 정보 및 제공받은 정보를 통해
              수집한 정보를 "회사"의 "서비스" 및 다른 매체에 제공하는 것에 대해
              동의합니다.
              <br />
              <br />
              2. "회사"는 자동 출금이체 서비스 제공 및 출금동의 확인, 출금이체
              신규등록 및 해지사실 통지를 위해 사단법인 금융결제원과
              ㈜하이픈코퍼레이션에 필요 정보를 제공하는 것을 동의합니다.
              <br />
              <br />
              3 "신청자"의 정보를 제공받은 제3자는 "회사"의 "서비스" 이용하는
              기간 동안에 한해 제공한 정보를 보유 및 이용할 수 있습니다.
              <br />
              <br />
              4. "신청자"는 정보를 제3자에게 제공하는 것을 거부할 권리가 있으며,
              권리 행사 시 "서비스" 신청이 거부될 수 있습니다.
            </div>
          </div>

          <div className="term-item">
            <div className="term-heading">제7조 서비스 해지</div>
            <div className="term-content">
              1. "서비스"의 해지 문의는 "신청자"가 직접 "회사"에 요청해야 하며,
              "회사"와 "신청자"의 확인을 거친 후 "서비스"가 해지됩니다.
              <br />
              <br />
              2. "회사"는 다음의 경우 "신청자"의 “서비스” 이용을 제한 및 해지 할
              수 있습니다.
              <br />
              <br />
              ① “매장”의 “서비스” 비용이 수납되지 않는 경우
              <br />② “신청자”가 사전통보 없이 3개월이상 연락 되지 않을 경우
            </div>
          </div>

          <div className="term-item">
            <div className="term-heading">제8조 서비스 비용 출금</div>
            <div className="term-content">
              1. “신청자"가 "회사"의 "서비스"를 신청하면 별도 통지 없이
              “서비스”의 비용이 "신청자"가 등록한 계좌정보로 "회사"가 정한
              출금일에 자동출금 납부됩니다.
              <br />
              <br />
              2. 자동출금은 "서비스" 시작일 전부터 시작되며, 매월 해당일에 자동
              출금되며, 미출금 시 재출금됩니다.
              <br />
              <br />
              3. 자동출금은 "회사"의 청구대로 출금하기로 하며, 출금금액에 이의가
              있는 경우에는 "신청자"와 "회사"가 협의하여 조정합니다.
              <br />
              <br />
              4. "신청자"가 신청한 정기납부 수단의 예금한도 잔액이 부족하거나
              지급제한 등으로 “서비스”의 비용의 납부가 불가능한 경우의 손해는
              "신청자"의 책임으로 합니다.
              <br />
              <br />
              5. "회사"가 정한 출금일에 동일한 수종의 자동 출금 청구가 있는
              경우의 출금 우선순위는 "신청자"의 해당 금융기관이 정하는 바에
              따르도록 합니다.
              <br />
              <br />
              6. "신청자"가 "서비스" 해지요청을 하는 경우 자동출금은 자동해지
              됩니다.
            </div>
          </div>

          <div className="term-item">
            <div className="term-heading">제9조 서비스 비용 환불</div>
            <div className="term-content">
              1. "신청자"는 다음 각 호의 경우 "회사"에 환불 요청을 할 수
              있습니다.
              <br />
              <br />
              ① "서비스"가 천재지변이 아닌 "회사"의 문제 등으로 중지된 경우
              <br />
              ② "매장"의 폐업으로 더 이상 "서비스"를 진행할 수 없는 경우
              <br />
              ③ "회사"가 "신청자"의 "서비스"를 이용 제한, 중지, 해지 한 경우
              <br />
              <br />
              2. 위 항에 한해서만 "회사"는 "신청자"에게 해지 된 시점부터 남은
              기간의 일할 계산한 금액을 익월 5일에 환불합니다.
            </div>
          </div>

          <div className="term-item">
            <div className="term-heading">제10조 책임 제한</div>
            <div className="term-content">
              1. “회사”는 천재지변 또는 이에 준하는 불가항력으로 인하여
              “서비스”를 제공할 수 없는 경우에는 “서비스” 제공에 대한 책임이
              면제됩니다.
              <br />
              <br />
              2. “회사”는 “신청자”의 귀책사유로 인한 “서비스” 제공을 하지 못하는
              경우에 대하여는 책임을 지지 않습니다.
              <br />
              <br />
              3. “회사”는 “신청자”가 “서비스”와 관련하여 제공한 정보의 신뢰도,
              정확성 등의 내용에 관하여는 책임을 지지 않습니다.
            </div>
          </div>

          <div className="term-item">
            <div className="term-heading">제11조 이용약관 외 준칙</div>
            <div className="term-content">
              본 약관에 정하지 아니한 사항에 관하여는 사회 일반에 명시적 또는
              묵시적으로 승인되어 행해오던 관례 및 관습에 준하여 정합니다.
            </div>
          </div>

          <div className="term-item">
            <div className="term-heading">제12조 분쟁의 해결 및 관할법원</div>
            <div className="term-content">
              본 약관은 대한민국법령에 의하여 규정되고 이행되며, "서비스" 이용과
              관련하여 "회사"와 "신청자"간에 분쟁이 발생할 경우 상호 합의하에
              해결하고, 합의가 이루어지지 아니할 경우 관할 법원은 "회사"의
              관할지법원으로 합니다.
            </div>
          </div>

          <div className="w-full mb-2">
          <SolidBlueBtn className="w-full mt-5">동의 하기</SolidBlueBtn>
        </div>
        </div>

        
      </div>
    </div>
  );
};

export default TermAndPolicyDetails;
